const $$splitComponentImporter = () => import('/src/src/routes/enrollment.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
export const Route = createFileRoute("/enrollment")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    referrer: z.string().optional(),
    invitationId: z.uuid().optional(),
    openInvitationId: z.uuid().optional()
  }))
});